var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-box"},[_c('div',{staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.msg)),(_vm.clickMsg != '')?_c('span',{on:{"click":_vm.msgClick}},[_vm._v(_vm._s(_vm.clickMsg))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }